export default __webpack_public_path__ + "static/media/lysningen-property-16.891a2326.jpg";